ceregoCommon.directive("cgEnter", [->
  (scope, element, attrs) ->
    element.bind "keydown keypress", (event) ->
      if event.which == 13
        scope.$apply ->
          scope.$eval attrs.cgEnter
        event.preventDefault()
])
